import e, { useRef as t, useEffect as r } from "react";
var s = function s(_ref) {
  var s = _ref.repo,
    u = _ref.label,
    i = _ref.theme,
    n = _ref.issueTerm,
    o = _ref.issueNumber;
  var m = t(null);
  return r(function () {
    if (!m.current) return;
    var e = function (_ref2) {
      var e = _ref2.repo,
        t = _ref2.label,
        r = _ref2.theme,
        s = _ref2.issueTerm,
        u = _ref2.issueNumber;
      var i = document.createElement("script");
      if (i.src = "https://utteranc.es/client.js", i.async = !0, i.setAttribute("repo", e), s) {
        var _e = Array.isArray(s) ? s.join(" ") : s;
        i.setAttribute("issue-term", _e);
      } else "number" == typeof u && i.setAttribute("issue-number", String(u));
      return i.setAttribute("crossorigin", "anonymous"), i.setAttribute("theme", r), t && i.setAttribute("label", t), i;
    }({
      repo: s,
      label: u,
      theme: i,
      issueTerm: n,
      issueNumber: o
    });
    var t, r;
    t = m.current, r = e, t.childNodes.forEach(function (e) {
      e.remove();
    }), t.appendChild(r);
  }, []), e.createElement("div", {
    ref: m
  });
};
export { s as Utterances };